import UAEAmountForm from "./forms/UAEAmountForm";
import UAEBeneficiaryForm from "./forms/UAEBeneficiaryForm";
import UAEReviewForm from "./forms/UAEReviewForm";
import { FormRegistryMap } from "../../shared/types";

export const uaeFormRegistry: FormRegistryMap = {
  amount: {
    bank_transfer: UAEAmountForm,
    default: UAEAmountForm,
  },
  beneficiary: {
    bank_transfer: UAEBeneficiaryForm,
    default: UAEBeneficiaryForm,
  },
  review: {
    bank_transfer: UAEReviewForm,
    default: UAEReviewForm,
  },
};
